import {
  CTX_RULE_PARTNER_PRODUCTS,
  CTX_RULE_PRODUCTS_NOVELTIES,
} from 'shared/consts'
import type { SortingItem } from 'shared/utils/algolia/types'

export const shouldInjectNoveltiesSortingOption = (
  ruleContexts: string[]
): boolean => {
  return Boolean(ruleContexts?.includes(CTX_RULE_PRODUCTS_NOVELTIES))
}

export const decorateNoveltiesSortingOptions = ({
  sortingItems,
  ruleContexts,
  noveltiesIndexName,
  label,
}: {
  sortingItems: SortingItem[]
  ruleContexts: string[]
  noveltiesIndexName: string
  label: string
}): SortingItem[] => {
  const isPartnerPage = Boolean(
    ruleContexts?.includes(CTX_RULE_PARTNER_PRODUCTS)
  )

  if (
    noveltiesIndexName &&
    sortingItems?.length &&
    (shouldInjectNoveltiesSortingOption(ruleContexts) || isPartnerPage)
  ) {
    sortingItems
      .filter(opt => opt.default)
      .forEach(opt => {
        opt.default = !isPartnerPage ? false : opt.default
      })

    if (isPartnerPage) {
      sortingItems.push({
        value: noveltiesIndexName,
        label,
        default: false,
      })
    } else {
      sortingItems.unshift({
        value: noveltiesIndexName,
        label,
        default: true,
      })
    }
  }

  return sortingItems
}
